export default __webpack_public_path__ + "static/media/CocoaBean2Chocolate_05.c9a3ba36.png";